import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useStyles } from "./styles";

type Props = {
  heading: string;
};

export default function Heading({ heading = "--" }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box color="text.secondary">
            <Typography className={classes.heading}>{heading}</Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
